module.exports = __webpack_public_path__ + "static/img/risk-icon2.255027ca.png";